// extracted by mini-css-extract-plugin
export default {"root":"t2FZ7a","icon":"_7fiSL"};